import { ROUTER_VARIABLES } from "@/base/utils/router-variables";
import { URLS } from "@/base/utils/urls";
import { useMaybeRouterVariables } from "@/components/routing-utils/useRouterVariables";
import { useIsFirstRender } from "@/flokit/utils/rendering/use-is-first-render";
import { useRedirectIf } from "@/flokit/utils/routing/use-redirect-if";
import PageWrapper from "../../../../../../components/PageWrapper";
import LaunchDarklyService from "../../../../../../components/services/launch-darkly.service";
import { JobApplicationPage } from "../../../../../../modules/self-apply/job-application/candidate/job-application/job-application";

const Page = () => {
  const routerVariables = useMaybeRouterVariables({
    [ROUTER_VARIABLES.org]: "string",
    [ROUTER_VARIABLES.jobExtension]: "string",
  });

  const isFirstRender = useIsFirstRender();

  useRedirectIf({
    // TODO: Anywhere else we should redirect to?
    href: "/",
    condition: routerVariables.org.isNothing() && !isFirstRender,
  });
  const assuredOrgFriendlyName = routerVariables.org.extract()!;

  useRedirectIf({
    href: URLS.selfApplyJobsList(routerVariables.org.extract()!),
    condition: routerVariables.jobExtension.isNothing() && !isFirstRender,
  });
  const assuredJobExtension = routerVariables.jobExtension.extract()!;

  return (
    <LaunchDarklyService flagName="selfApplyJobDetailsPage">
      <PageWrapper title="Application">
        <JobApplicationPage
          orgFriendlyName={assuredOrgFriendlyName}
          jobExtension={assuredJobExtension}
        />
      </PageWrapper>
    </LaunchDarklyService>
  );
};

export default Page;
